/**
 * ⚠️ WARNING: DO NOT MODIFY THIS FILE DIRECTLY ⚠️
 *
 * This file is auto-generated from roles/roles.yaml
 * To make changes to roles or role-related functionality:
 * 1. Edit roles/roles.yaml
 * 2. Run 'yarn generate:roles'
 *
 * Any direct modifications to this file will be overwritten.
 */
export const ROLES = {
    ORGANIZATION_ADMIN: 'organization_admin',
    PRO_APPROVER: 'pro_approver',
    PRO_RESTRICTED: 'pro_restricted',
    PRO_USER: 'pro_user',
    PULSE_USER: 'pulse_user',
    SYSTEM_ADMIN: 'system_admin',
    DEVELOPER: 'developer',
};
export const ROLE_DEFINITIONS = {
    organization_admin: {
        description: 'Administrator role with full access to the logged in organization',
        user_facing: true,
    },
    pro_approver: {
        description: 'Elevated PRO user with access to the logged in organization, and the ability to approve submitted studies',
        user_facing: true,
    },
    pro_restricted: {
        description: 'Restricted PRO user with basic access to the logged in organization, and the ability to submit studies for approval',
        user_facing: true,
    },
    pro_user: {
        description: 'Standard PRO user with basic access to the logged in organization',
        user_facing: true,
    },
    pulse_user: {
        description: 'Standard Pulse user with basic access to the logged in organization',
        user_facing: true,
    },
    system_admin: {
        description: 'Super administrator with cross-organization access (can manage all organizations, limited to WEVO employees)',
        user_facing: false,
    },
    developer: {
        description: 'Use with access to development tools and resources',
        user_facing: false,
    },
};
/**
 * Type guard to check if a string is a valid role
 */
export const isValidRole = (role) => {
    return Object.values(ROLES).includes(role);
};
//# sourceMappingURL=roles.js.map